'use strict';

module.exports = Object.freeze({
  'individual_thought_leader': 'Individual',
  'informal_organization': 'Group',
  'small_business': 'Small Business',
  'ngo': 'Non-profit (NGO)',
  'association': 'Association',
  'faithbased_religious': 'Faith-based / Religious',
  'academic_entity': 'Academic / Educational',
  'government': 'Government / Political',
  'corporation': 'Corporate Enterprise',
  'sole_proprietorship': 'Sole Proprietorship',
});
